import PropTypes from 'prop-types';
import React from 'react';

const Option = ({ category }) =>
  <option value={category.id}>{category.displayName}</option>;

Option.propTypes = {
  category: PropTypes.object.isRequired,
};

export default Option;
